/** a miniature of the app in one theme: sidebar rail, header, content rows.
 *
 *  the colours are literals rather than tokens on purpose. this has to paint
 *  the theme it is offering, not the theme currently applied, so it cannot
 *  inherit from :root the way everything else does.
 */
const PALETTES = {
  light: {
    page: '#faf9f7',
    rail: '#f2f0ec',
    line: '#e4e1da',
    ink: '#0f0f0f',
    soft: '#c9c5bc'
  },
  dark: {
    page: '#0e0e10',
    rail: '#16161a',
    line: '#2a2a30',
    ink: '#f5f4f1',
    soft: '#3f3f47'
  }
} as const

export function ThemePreview({ theme }: { theme: 'light' | 'dark' }) {
  const c = PALETTES[theme]

  return (
    <div
      aria-hidden
      className='flex h-[92px] w-full overflow-hidden rounded-lg border'
      style={{ background: c.page, borderColor: c.line }}
    >
      <div
        className='flex w-[34%] flex-col gap-1.5 border-r p-2'
        style={{ background: c.rail, borderColor: c.line }}
      >
        <div
          className='h-1.5 w-3/4 rounded-full'
          style={{ background: c.ink, opacity: 0.75 }}
        />
        <div
          className='h-1.5 w-full rounded-full'
          style={{ background: c.soft }}
        />
        <div
          className='h-1.5 w-2/3 rounded-full'
          style={{ background: c.soft }}
        />
        <div
          className='h-1.5 w-5/6 rounded-full'
          style={{ background: c.soft }}
        />
      </div>
      <div className='flex flex-1 flex-col gap-1.5 p-2'>
        <div
          className='h-1.5 w-1/2 rounded-full'
          style={{ background: c.ink, opacity: 0.75 }}
        />
        <div
          className='mt-1 h-8 w-full rounded'
          style={{ border: `1px solid ${c.line}` }}
        />
        <div
          className='h-1.5 w-4/5 rounded-full'
          style={{ background: c.soft }}
        />
      </div>
    </div>
  )
}
